import { postJson } from "../methods";
function createRecentlyViewedCompany(payload, headers = {}) {
  return postJson({
    url: "dashboard/recently-viewed",
    headers,
    payload
  });
}
export {
  createRecentlyViewedCompany as default
};
